<template>
  <ul class="collection collection-alone with-header" id="filter4">
    <li class="collection-header pl-0">
      <span class="Search__title grey-text pl-0">{{ title }}</span>
    </li>
    <li
      class="collection-item dismissable pb-0"
      style="
        touch-action: pan-y;
        -webkit-user-drag: none;
        -webkit-tap-highlight-color: rgba(0, 0, 0, 0);"
      v-for="item in produtosPadrao"
      v-bind:key="item.produto_id"
    >
      <input
        type="checkbox"
        v-model="produtos"
        :value="item.produto_id"
        :id="'produto'+item.produto_id"
        v-on:change="$emit('change', produtos)"
      >
      <label :for="'produto'+item.produto_id"></label>
      <span class="title title-alone" style="width: 100%">{{ item.produto_nome }}</span>
    </li>
  </ul>
</template>

<script>
import { get } from "@/helpers/api";

export default {
  name: "FiltroPorProdutos",

  props: {
    title: {
      type: String,
      default: undefined
    },
    produtos: {
      type: Array,
      default: () => [],
    }
  },

  data() {
    return {
      produtosPadrao: []
    }
  },

  mounted() {
    get("produto")
    .then(response => {
      this.produtosPadrao = response.data.result.data;
    });
  },

  methods: {},
};
</script>





// WEBPACK FOOTER //
// src/components/lead/listagem/FiltroPorProduto.vue